import { api } from '../axiosInstance';
import { ApiResponseType } from '../type/commonTypes';
import { PostReissueResponse } from '../type/types';

// 인증 토큰 재발급
export const postReIssue = async () => {
  const res = await api.post<ApiResponseType<PostReissueResponse>>(
    '/api/auth/reissue',
    {},
    {
      headers: {
        'X-Auth-Method': 'COOKIE',
      },
    }
  );
  return res.data;
};
